import OnDOMReady from "shared/util/OnDOMReady";
import { voucherCheck } from "shared/components/VoucherModal/helpers";

OnDOMReady(() => {
	voucherCheck();
});



// WEBPACK FOOTER //
// ./src/shared/util/voucherCheck.js